import { GenericSelectComponents as components } from '../../GenericSelectControl/GenericSelectControl';
import { withClassName } from '../helper';
export var LookupPlaceholder = withClassName(components.Placeholder, 'placeholder');